<template>
  <div>
    <videoplayer v-bind:postsrc="'/videos/Assistenzhunde/Führen_SD_WEB.mp4'" v-bind:autoplay="true"></videoplayer>
  </div>
</template>

<style>
</style>

<script>
import videoplayer from '@/components/Includes/videoplayer.vue'
export default {
  name: 'AHmain',
  components: {
    videoplayer
  },
  props: {
    msg: String
  },
  mounted () {
    document.body.style.background = 'rgb(225, 134, 143)'
    document.getElementsByTagName('nav')[0].style.background = 'rgb(225, 134, 143)'
    this.$store.commit('toggleMenu', false)
  },
  ready () {
    document.getElementsByClassName('video-player-box')[0].style.width = '1066px'
  }
}
</script>
